(() => {
    'use strict';

    const getSiteId = () => {
        if (window.arNextOptions?.SITE_ID) {
            return window.arNextOptions.SITE_ID;
        }

        if (window.BX && typeof window.BX.message === 'function') {
            return window.BX.message('SITE_ID') || 's1';
        }

        return 's1';
    };

    const escapeRegExp = (value) => value.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');

    const getCookie = (name) => {
        const matches = document.cookie.match(new RegExp(`(?:^|; )${escapeRegExp(name)}=([^;]*)`));

        return matches ? decodeURIComponent(matches[1]) : null;
    };

    const setCookie = (name, value, days) => {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
    };

    const readJsonCookie = (name) => {
        const value = getCookie(name);

        return value ? JSON.parse(value) : {};
    };

    const readStorage = (key) => {
        if (window.BX?.localStorage && typeof window.BX.localStorage.get === 'function') {
            return window.BX.localStorage.get(key) || {};
        }

        const value = window.localStorage.getItem(key);

        return value ? JSON.parse(value) : {};
    };

    const writeStorage = (key, value) => {
        if (window.BX?.localStorage && typeof window.BX.localStorage.set === 'function') {
            window.BX.localStorage.set(key, value, 2592000);
            return;
        }

        window.localStorage.setItem(key, JSON.stringify(value));
    };

    window.setViewedProduct = (id, productData) => {
        try {
            if (!id || !productData) {
                return;
            }

            const siteId = getSiteId();
            const localKey = `NEXT_VIEWED_ITEMS_${siteId}`;
            const productId = productData.PRODUCT_ID || id;
            const time = Date.now();

            const viewedLocal = readStorage(localKey);
            const viewedCookie = readJsonCookie(localKey);

            Object.keys(viewedLocal).forEach((itemId) => {
                viewedLocal[itemId].IS_LAST = false;

                if (typeof viewedCookie[itemId] === 'undefined') {
                    delete viewedLocal[itemId];
                }
            });

            Object.keys(viewedCookie).forEach((itemId) => {
                if (typeof viewedLocal[itemId] === 'undefined') {
                    delete viewedCookie[itemId];
                }
            });

            if (
                viewedLocal[productId] &&
                viewedLocal[productId].ID &&
                String(viewedLocal[productId].ID) !== String(id)
            ) {
                delete viewedLocal[productId];
                delete viewedCookie[productId];
            }

            const nextProductData = {
                ...productData,
                ID: id,
                ACTIVE_FROM: time,
                IS_LAST: true,
            };

            viewedLocal[productId] = nextProductData;
            viewedCookie[productId] = [String(time), productData.PICTURE_ID || false];

            writeStorage(localKey, viewedLocal);
            setCookie(localKey, JSON.stringify(viewedCookie), 30);
        } catch (error) {
            console.error(error);
        }
    };
})();
